import { makeAutoObservable } from 'mobx';

class MergeFieldViewModel {
  name;
  key;
  annotationType;
  alreadyTranslated;

  constructor({name, key, annotationType, alreadyTranslated}) {
    makeAutoObservable(this);

    this.name = name;
    this.key = key;
    this.annotationType = annotationType;
    this.alreadyTranslated = alreadyTranslated;
  }

  static fromHash({key, name, annotationType, alreadyTranslated = false}) {
    return new MergeFieldViewModel({
      name,
      key,
      alreadyTranslated,
      annotationType: annotationType || 'variable'
    });
  }
}

export default MergeFieldViewModel;
